import React, { useState, useRef, useEffect } from "react";
import ListInfo from "../CourseInfo/Course/CourseInfoCreate.module.css";
import styles from "./ListCourseInfo.module.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AxiosInstance } from "../../../../axios";
import { styled } from "@mui/material/styles";
import Loader from "../../Loader";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import Pagination from "../../../ReusuableComponent/Pagination/Pagination";
import CustomDownloadButton from "../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
import { R_PER_PAGE } from "../../../../labels";
// import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import ConfirmationPopup from "../TestAdminWorkflow/Gallery/ConfirmationPopup/ConfirmationPopup";
// import { ExportTableToPdf } from "../../../ReusuableComponent/ExportTableToPdf";

function ListTestTopicInfo() {
  const location = useLocation();
  const navigate = useNavigate();
  const { filType, filCateCode, fillCourse, filSubject, filSearch } =
    location.state || {};
  const txtBSearch = useRef(null);
  const filterTypeRef = useRef(null);
  const filterCategoryRef = useRef(null);
  const filterCourseRef = useRef(null);
  const filterSubjectRef = useRef(null);
  let page = R_PER_PAGE;
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [categoryId, setCategoryId] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [updateListData, setUpdateListData] = useState([]);
  const [updateChipData, setUpdateChipData] = useState([]);
  const [search, setSearch] = useState("");
  const [search1, setSearch1] = useState("");
  const [isOpen, setIsOpen] = useState({
    type: false,
    category: false,
    course: false,
    subject: false,
  });
  const [csvData, setCsvData] = useState([]);
  const [typeOn, setTypeOn] = useState([]);
  const [courseOn, setCourseOn] = useState([]);
  const [category_on, setCategory_on] = useState([]);
  const [subject_on, setSubject_on] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedBooks, setSelectedBooks] = useState([]);
  const [courseID, setCourseID] = useState([]);
  const [subjectId, setsubjectId] = useState([]);
  const testTopicMasterIds = selectedBooks.map((item) => item.test_topic_id);
  const filterRef = useRef(null);
  const filterRefss = useRef(null);
  const filterCourseRefss = useRef(null);
  let filterSearch = [];
  let filterCategory = [];
  let filterType = [];
  let filterCourse = [];
  let filterSubject = [];
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);
  useEffect(() => {
    if (filType && filType.length > 0) {
      setTypeOn(filType);
      filterType = filType;
    } else {
      setTypeOn(typeOn);
      filterType = typeOn;
    }
    if (filCateCode && filCateCode.length > 0) {
      setCategory_on(filCateCode);
      filterCategory = filCateCode;
    } else {
      setCategory_on(category_on);
      filterCategory = category_on;
    }
    if (fillCourse && fillCourse.length > 0) {
      setCourseOn(fillCourse);
      filterCourse = fillCourse;
    } else {
      setCourseOn(courseOn);
      filterCourse = courseOn;
    }
    if (filSubject && filSubject.length > 0) {
      setSubject_on(filSubject);
      filterSubject = filSubject;
    } else {
      setSubject_on(subject_on);
      filterSubject = subject_on;
    }
    if (filSearch && filSearch.length > 0) {
      setSearchTerm(filSearch);
      filterSearch = [{ name: "" + filSearch, type: "search" }];
    }
    //  else {
    //   setSearchTerm(subject_on);
    //   filterSearch = subject_on;
    // }
    setIsFiltersInitialized(true);
    loadChipdata();
  }, [filType, filCateCode, filSubject, fillCourse, filSearch]);
  useEffect(() => {
    if (isFiltersInitialized && filSearch && filSearch.length > 0) {
      loadListdata();
    } else if (isFiltersInitialized && filSearch && filSearch.length > 0) {
      loadListdata();
    }
  }, [
    filType,
    filCateCode,
    filSubject,
    fillCourse,
    filSearch,
    isFiltersInitialized,
    updateChipData,
  ]);
  useEffect(() => {
    if (isFiltersInitialized) {
      loadListdata();
    }
  }, [isFiltersInitialized, updateChipData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;
      if (
        filterTypeRef.current &&
        !filterTypeRef.current.contains(event.target)
      ) {
        const hasType = updateChipData.some(
          (chipItem) => chipItem.type === "typeOn"
        );
        if (hasType) {
          const updatedTypeOn = updateChipData.filter(
            (chipItem) => chipItem.type === "typeOn"
          );

          setTypeOn(updatedTypeOn);
        } else {
          setTypeOn([]);
        }
        setIsOpen((prev) => ({ ...prev, type: false }));
      }
      if (
        filterCategoryRef.current &&
        !filterCategoryRef.current.contains(event.target)
      ) {
        const hasCategory = updateChipData.some(
          (chipItem) => chipItem.type === "category_on"
        );
        if (hasCategory) {
          const updateCategory = updateChipData.filter(
            (chipItem) => chipItem.type === "category_on"
          );
          setCategory_on(updateCategory);
        } else {
          setCategory_on([]);
        }
        setIsOpen((prev) => ({ ...prev, category: false }));
      }
      if (
        filterCourseRef.current &&
        !filterCourseRef.current.contains(event.target)
      ) {
        const hasCourse = updateChipData.some(
          (chipItem) => chipItem.type === "courseOn"
        );
        if (hasCourse) {
          const updatedMedium = updateChipData.filter(
            (chipItem) => chipItem.type === "courseOn"
          );
          setCourseOn(updatedMedium);
        } else {
          setCourseOn([]);
        }
        setIsOpen((prev) => ({ ...prev, course: false }));
      }
      if (
        filterSubjectRef.current &&
        !filterSubjectRef.current.contains(event.target)
      ) {
        const hasSubject = updateChipData.some(
          (chipItem) => chipItem.type === "subject"
        );
        if (hasSubject) {
          const updatedMedium = updateChipData.filter(
            (chipItem) => chipItem.type === "subject"
          );
          setSubject_on(updatedMedium);
        } else {
          setSubject_on([]);
        }
        setIsOpen((prev) => ({ ...prev, subject: false }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData]);

  useEffect(() => {
    filterCategory = category_on;
  }, [category_on]);

  useEffect(() => {
    filterType = typeOn;
  }, [typeOn]);

  useEffect(() => {
    filterCourse = courseOn;
  }, [courseOn]);

  useEffect(() => {
    filterSubject = subject_on;
  }, [subject_on]);

  // useEffect(() => {
  //   loadListdata();
  // }, [updateChipData]);

  function updateStateData() {
    filterType = typeOn;
    filterCategory = category_on;
    filterCourse = courseOn;
    filterSubject = subject_on;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }

  const handleSearch = (event) => {
    if (event.key === "Enter") {
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };

  const handleSort = (event, sortKey) => {
    event.preventDefault();

    const order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);

    const sortedList = [...updateListData].sort((a, b) => {
      const aVal = a[sortKey] ?? "";
      const bVal = b[sortKey] ?? "";

      // Numeric sort if both values are numbers
      if (!isNaN(aVal) && !isNaN(bVal)) {
        return order === "asc" ? aVal - bVal : bVal - aVal;
      }

      // String sort (case-insensitive)
      if (typeof aVal === "string" && typeof bVal === "string") {
        return order === "asc"
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      }

      // Default fallback
      return 0;
    });

    setUpdateListData(sortedList);
  };

  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (typename === "category_on") {
      if (checked) {
        setCategory_on([
          ...category_on,
          { id: value, name: name, type: "category_on" },
        ]);
        // setIsOpen((prev) => ({ ...prev, course: false }));
      } else {
        setCategory_on(category_on.filter((item) => item.id !== value));
      }
    } else if (typename === "typeOn") {
      if (checked) {
        setTypeOn([...typeOn, { id: value, name: name, type: "typeOn" }]);
        // setIsOpen((prev) => ({ ...prev, course: false }));
      } else {
        setTypeOn(typeOn.filter((item) => item.id !== value));
      }
    } else if (typename === "courseOn") {
      if (checked) {
        setCourseOn([...courseOn, { id: value, name: name, type: "courseOn" }]);
      } else {
        setCourseOn(courseOn.filter((item) => item.id !== value));
      }
    } else if (typename === "subject") {
      if (checked) {
        setSubject_on([
          ...subject_on,
          { id: value, name: name, type: "subject" },
        ]);
      } else {
        setSubject_on(subject_on.filter((item) => item.id !== value));
      }
    }
  };

  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  const handleApplyFilter = (name, event) => {
    updateStateData();
    if (name === "category_on") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "typeOn") {
      loadChipdata();
      setIsOpen({
        ...isOpen,

        type: false,
      });
    } else if (name === "courseOn") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        course: false,
      });
    } else if (name === "subject") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        subject: false,
      });
    }
  };
  const handleAllClear = () => {
    setSearchTerm([]);
    setTypeOn([]);
    setCategory_on([]);
    setCourseOn([]);
    setSubject_on([]);
    setUpdateChipData([]);
    // setUpdateListData([]);
    loadListdata();
    navigate(location.pathname, { replace: true });
  };
  const handleClear = (name) => {
    updateStateData();
    if (name === "courseOn") {
      setCourseOn([]);
      filterCourse = [];
      setIsOpen({
        ...isOpen,
        course: false,
      });
    } else if (name === "category_on") {
      setCategory_on([]);
      filterCategory = [];
      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "typeOn") {
      setTypeOn([]);
      filterType = [];
      setIsOpen({
        ...isOpen,
        type: false,
      });
    } else if (name === "subject") {
      setSubject_on([]);
      filterSubject = [];
      setIsOpen({
        ...isOpen,
        subject: false,
      });
    }
    loadChipdata();
  };

  useEffect(() => {
    AxiosInstance.get("api/course/category_list")
      .then((res) => {
        if (res.status === 200 && Array.isArray(res.data.data)) {
          setIsLoading(false);
          setCategoryId(res.data.data);
        } else if (res.data.status === false) {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setUpdateListData([]);
        setIsLoading(false);
        return error;
      });
  }, []);

  const filteredCourses = courseID.filter((el) =>
    el.name.toLowerCase().includes(search.toLowerCase())
  );

  const filteredSubject = subjectId.filter((el) =>
    el.name.toLowerCase().includes(search1.toLowerCase())
  );

  const handleSubjectSearch = (event, value = null) => {
    let val = value !== null ? value : event.target.value; // Use passed value or input value
    setSearch1(val);
  };

  const handleCourseSearch = (event, value = null) => {
    let val = value !== null ? value : event.target.value; // Use passed value or input value
    setSearch(val);
  };

  // useEffect(() => {
  //   if (category_on.length > 0 && typeOn.length > 0) {
  //     let temptypeons = [];
  //     let tempcategorys = [];
  //     typeOn.map((obj) => {
  //       temptypeons.push(obj.id);
  //     });
  //     category_on.map((obj) => {
  //       tempcategorys.push(obj.id);
  //     });
  //     AxiosInstance.post("api/course/testlist", {
  //       category_id: category_on.length > 0 ? parseInt(tempcategorys[0]) : "",
  //       type: typeOn.length > 0 ? parseInt(temptypeons[0]) : "",
  //       search: "",
  //       course_id: "",
  //       subject_id: "",
  //     })
  //       .then((res) => {
  //         setCurrentPage(1);
  //         const courseArray = [];
  //         res.data.data.forEach((item) => {
  //           const exists = courseArray.some(
  //             (course) => course.id === item.course_id
  //           );
  //           if (!exists) {
  //             courseArray.push({
  //               id: item.course_id,
  //               name: item.course_name,
  //             });
  //           }
  //         });
  //         setCourseID(courseArray);
  //         const subjectArray = [];
  //         res.data.data.forEach((item) => {
  //           const exists = subjectArray.some(
  //             (subject) => subject.id === item.subject_id
  //           );
  //           if (!exists) {
  //             subjectArray.push({
  //               id: item.subject_id,
  //               name: item.subject,
  //             });
  //           }
  //         });
  //         setsubjectId(subjectArray);
  //       })
  //       .catch((error) => {
  //         setCourseID([]);
  //         return error;
  //       });
  //   }
  // }, [category_on, typeOn]);

  function loadListdata() {
    let temptypeon = [];
    let tempcategory = [];
    let tempCourseI = [];
    let tempSubje = [];
    typeOn.map((obj) => {
      temptypeon.push(parseInt(obj.id));
    });
    category_on.map((obj) => {
      tempcategory.push(parseInt(obj.id));
    });
    courseOn.map((obj) => {
      tempCourseI.push(parseInt(obj.id));
    });
    subject_on.map((obj) => {
      tempSubje.push(parseInt(obj.id));
    });

    let statusFilter = {
      category_id: category_on.length > 0 ? tempcategory : "",
      type: typeOn.length > 0 ? temptypeon : "",
      search: searchTerm.length > 0 ? searchTerm : "",
      course_id: courseOn.length > 0 ? tempCourseI : "",
      subject_id: subject_on.length > 0 ? tempSubje : "",
    };
    setIsLoading(true);
    AxiosInstance.post("api/course/testlist", statusFilter)
      .then((res) => {
        if (res.status === 200) {
          setCurrentPage(1);
          setIsLoading(false);
          const fiata = res?.data?.data;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          const csvFormattedData = serialNumberAddedData.map((item) => ({
            serialNumber: item.serialNumber,
            test_topic_name: item.test_topic_name,
            subject: item.subject,
            type:
              item.type === 0
                ? "Course"
                : item.type === 1
                ? "Test Batch"
                : item.type === 3
                ? "Special Class"
                : item.type === 2
                ? "Counselling"
                : item.type === 5
                ? "Mock Interview"
                : "Model Exam",
            category: item.category,
            course_name: item.course_name,
          }));
          // Set CSV data
          setCsvData(csvFormattedData);
          setUpdateListData(serialNumberAddedData);
          const courseArray = [];
          res?.data?.data.forEach((item) => {
            const exists = courseArray.some(
              (course) => course.id === item.course_id
            );
            if (!exists) {
              courseArray.push({
                id: item.course_id,
                name: item.course_name,
              });
            }
          });
          setCourseID(courseArray);
          const subjectArray = [];
          res.data.data.forEach((item) => {
            const exists = subjectArray.some(
              (subject) => subject.id === item.subject_id
            );
            if (!exists) {
              subjectArray.push({
                id: item.subject_id,
                name: item.subject,
              });
            }
          });
          setsubjectId(subjectArray);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setsubjectId([]);
          setCourseID([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setsubjectId([]);
        setCourseID([]);
        setUpdateListData([]);
        setIsLoading(false);
        return error;
      });
  }

  function loadChipdata() {
    let tempArr = [];

    filterSearch.map((obj) => {
      tempArr.push(obj);
    });

    filterSubject.map((obj) => {
      tempArr.push(obj);
    });

    filterCourse.map((obj) => {
      tempArr.push(obj);
    });

    filterCategory.map((obj) => {
      tempArr.push(obj);
    });

    filterType.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
  }

  // const handleDelete = (chipToDelete, index) => () => {
  //   updateStateData();
  //   if (chipToDelete.type === "search") {
  //     setSearchTerm("");
  //     filterSearch = [];
  //   } else if (chipToDelete.type === "subject") {
  //     setSubject_on([]);
  //     filterSubject = [];
  //   } else if (chipToDelete.type === "courseOn") {
  //     setCourseOn([]);
  //     filterCourse = [];
  //   }
  //   loadChipdata();
  // };

  const handleDelete = (chipToDelete, index) => () => {
    const updatedChips = updateChipData.filter(
      (item) =>
        !(item.type === chipToDelete.type && item.id === chipToDelete.id)
    );
    setUpdateChipData(updatedChips);
    if (chipToDelete.type === "category_on") {
      setCategory_on(category_on.filter((item) => item.id !== chipToDelete.id));
      setUpdateChipData((prev) => {
        return prev.filter(
          (e) => !(e.type === "category_on" && e.id === chipToDelete.id)
        );
      });
    } else if (chipToDelete.type === "courseOn") {
      const filterCourse = courseOn.filter(
        (item) => item.id !== chipToDelete.id
      );
      setCourseOn(filterCourse);
    } else if (chipToDelete.type === "subject") {
      const filterSubject = subject_on.filter(
        (item) => item.id !== chipToDelete.id
      );
      setSubject_on(filterSubject);
    } else if (chipToDelete.type === "typeOn") {
      setTypeOn(typeOn.filter((item) => item.id !== chipToDelete.id));
      setUpdateChipData((prev) => {
        return prev.filter(
          (e) => !(e.type === "typeOn" && e.id === chipToDelete.id)
        );
      });
    } else if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
      setUpdateChipData((prev) => {
        const filteredData = prev.filter((e) => e.type !== "search");
        return filteredData;
      });
    }
  };
  useEffect(() => {
    if (location.state) {
      // Optionally do something here if needed
    }
  }, [location.state]);

  useEffect(() => {
    // Clear state only once AFTER all tabs are rendered
    if (location.state) {
      const timer = setTimeout(() => {
        navigate(location.pathname, { replace: true, state: null });
      }, 100); // give child tabs time to read it
      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  const handleFilter = (e, boxName) => {
    if (boxName === "category") {
      setIsOpen((prevState) => ({
        type: false,
        subject: false,
        course: false,
        category: !prevState.category,
      }));
      setCategory_on(updateChipData.filter((ui) => ui.type === "category_on"));
    } else if (boxName === "type") {
      setIsOpen((prevState) => ({
        category: false,
        subject: false,
        course: false,
        type: !prevState.type,
      }));
      setTypeOn(updateChipData.filter((ui) => ui.type === "typeOn"));
    } else if (boxName === "course") {
      setIsOpen((prevState) => ({
        category: false,
        type: false,
        subject: false,
        course: !prevState.course,
      }));
    } else if (boxName === "subject") {
      setIsOpen((prevState) => ({
        category: false,
        type: false,
        course: false,
        subject: !prevState.subject,
      }));
    }
  };

  const totalPages = Math.ceil(updateListData.length / rowsPerPage);

  const handlePrev = (val) => {
    setCurrentPage(val);
  };

  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    setUpdateListData([]);
    loadListdata();
  };

  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = updateListData.slice(start, end);

  const handleReadView = (id) => {
    navigate(`/ViewTestTopic/${id}`, {
      state: {
        FCAT: category_on,
        FTYPE: typeOn,
        FCOUR: courseOn,
        FSUB: subject_on,
        FSEARCHTERM: searchTerm,
      },
    });
  };

  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });
      txtBSearch.current.dispatchEvent(event);
    }
  };

  const handleChangeBookOrder = (e, bookId) => {
    setSelectedBooks((prev) => {
      let updatedBooks;
      if (e.target.checked) {
        const bookToAdd = currentData.find(
          (book) => book.test_topic_id === bookId
        );
        if (bookToAdd) {
          updatedBooks = [...prev, bookToAdd]; // Add book to the selectedBooks array
        } else {
          updatedBooks = prev; // If book is not found, return previous state
        }
      } else {
        updatedBooks = prev.filter((book) => book.test_topic_id !== bookId); // Remove book from the array
      }
      return updatedBooks;
    });
  };

  const handleDelTestTopics = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  const handleSubmit = () => {
    AxiosInstance.post("api/course/delete/test_topics", {
      id: testTopicMasterIds,
    }).then((res) => {
      if (res.data.status === true) {
        toast.success(res.data.message);
        handleClose();
        loadListdata();
        setSelectedBooks([]);
      } else {
        toast.error(res.data.message);
        handleClose();
        loadListdata();
        setSelectedBooks([]);
      }
    });
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const generatePDF = () => {
    const headers = [
      "S.No",
      "Topic",
      "Subject",
      "Type of Admission",
      "Category",
      "Course",
    ];

    const rows = csvData.map((item, index) => [
      index + 1,
      item.test_topic_name,
      item.subject,
      item.type === 0
        ? "Course"
        : item.type === 1
        ? "Test Batch"
        : item.type === 3
        ? "Special Class"
        : item.type === 2
        ? "Counselling"
        : item.type === 5
        ? "Mock Interview"
        : "Model Exam",
      item.category ?? "",
      item.course_name ?? "",
    ]);
    if (rows.length <= 500) {
      navigate("/preview", {
        state: {
          title: "Topics Data",
          headers,
          rows,
          filename: "Topics.pdf",
          autoPrint: true,
        },
      });
    } else {
      toast.error(
        "The PDF cannot be generated because the data exceeds 500 records. Please apply filters and try again."
      );
    }
  };

  const csvHeaders = [
    { label: "S.No", key: "serialNumber" },
    { label: "Topic", key: "test_topic_name" },
    { label: "Subject", key: "subject" },
    { label: "Type of Admission", key: "type" },
    { label: "Category", key: "category" },
    { label: "Course", key: "course_name" },
  ];

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <>
      {showModal && (
        <ConfirmationPopup
          open={showModal}
          title="Remove Topic(s)"
          message="Are you sure you want to remove the selected topic(s)?"
          onConfirm={handleSubmit}
          onCancel={handleClose}
        />
      )}

      <div
        className={`${ListInfo.CourseInfoSec} ${styles.cm_ListViewForm} container-fluid global_container p-0`}
      >
        <div className="row ">
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
            <div class="input-group ">
              <input
                ref={txtBSearch}
                type="text"
                class={styles.Inputs}
                id="SearchInput"
                name="SearchInput"
                placeholder="Search by topic"
                onKeyDown={handleSearch}
              />

              <span
                class={styles.input_group_text}
                id="SearchInput"
                onClick={handleSearchFocus}
              >
                <span
                  className="material-icons"

                  // onClick={handleSearchFocus}
                >
                  search
                </span>
              </span>
            </div>
          </div>

          <div className="col-md-12 col-lg-8 ListBtn">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  className={`primaryButton ${
                    selectedBooks.length > 0 ? "" : "disabledbtn"
                  }`}
                  variant="primary"
                  disabled={selectedBooks.length === 0}
                  onClick={
                    selectedBooks.length > 0 ? handleDelTestTopics : undefined
                  }
                >
                  Remove Topic(s)
                </Link>
              </li>

              <li class="ListBtnItems">
                <CustomDownloadButton
                  csvListData={csvData.length > 0 ? csvData : []}
                  headers={csvHeaders}
                  iconName=" file_download "
                  filename={"Topic.csv"}
                  csvName="Download as CSV"
                />
              </li>
              <li class="ListBtnItems primaryButton" onClick={generatePDF}>
                <span className="material-icons me-1 align-middle text-white">
                  file_download
                </span>
                Download as PDF
              </li>
              <li class="ListBtnItems">
                <Link
                  to="/AddTestTopic"
                  className="primaryButton "
                  variant="primary"
                >
                  Create New Topic
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {updateChipData.filter((kl) => kl.name !== "ActiveTab").length > 0 ? (
          <div className="row mt-3">
            <div className="col-md-12 col-sm-12 col-xs-12 paperil_global ">
              <Paper
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  listStyle: "none",
                  p: 0.5,
                  m: 0,
                }}
                component="ul"
              >
                {updateChipData
                  .filter((kl) => kl.name !== "ActiveTab")
                  .map((data, index) => {
                    let icon;
                    let key = "" + data.name;
                    return (
                      <ListItem key={data}>
                        <Chip
                          icon={icon}
                          label={key}
                          onDelete={handleDelete(data, index)}
                        />
                      </ListItem>
                    );
                  })}

                <ListItem className="clearAll_list">
                  <a
                    className="clearAll_listItem"
                    href="javascript:void(0)"
                    onClick={handleAllClear}
                  >
                    Clear All Filters
                  </a>
                </ListItem>
              </Paper>
            </div>
          </div>
        ) : (
          <div></div>
        )}

        <div className="row mx-0 mt-2">
          <div className="col-md-12 table-responsive tableMinHeight px-0">
            <table className="table" id="tableListHeader">
              <thead>
                <tr>
                  {/* S.No. */}

                  <th id="th" className={styles.tableThPadding}></th>

                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      S.No
                    </span>

                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      import_export{" "}
                    </span>
                  </th>

                  {/* Test Topic */}

                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "test_topic_name")}
                    >
                      {" "}
                      Topic
                    </span>

                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort(e, "test_topic_name")}
                    >
                      import_export{" "}
                    </span>
                  </th>
                  {/* Subject */}
                  <th id="th" ref={filterSubjectRef}>
                    <span
                      className="textHead_th px-1"
                      onClick={(e) => handleSort(e, "subject")}
                    >
                      {" "}
                      Subject
                    </span>
                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort(e, "subject")}
                    >
                      import_export{" "}
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        subject_on.length > 0 || isOpen.subject
                          ? ListInfo.active_icons
                          : ""
                      }`}
                      onClick={(e) => handleFilter(e, "subject")}
                    >
                      filter_list
                    </span>
                    {isOpen.subject && (
                      <>
                        <div className="filterBoxs_testlist">
                          <div className="col-md-12 form-check filterStatus_list">
                            <ul className="ulFilterListData">
                              <div
                                class="input-group "
                                style={{
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 10,
                                  backgroundColor: "white",
                                  padding: "8px",
                                }}
                              >
                                <input
                                  // ref={txtBSearch}
                                  type="text"
                                  class={styles.Inputs}
                                  id="SearchInput"
                                  name="SearchInput"
                                  value={search1}
                                  placeholder="Search by subject"
                                  onChange={(e) => handleSubjectSearch(e)}
                                />

                                <span
                                  class={styles.input_group_text}
                                  id="SearchInput"
                                  onClick={() =>
                                    handleSubjectSearch(null, search1)
                                  }
                                >
                                  <span className="material-icons">search</span>
                                </span>
                              </div>

                              {filteredSubject.map((el) => (
                                <li className="filterListData">
                                  <input
                                    className="ListCheckbox"
                                    type="checkbox"
                                    name={el.name}
                                    value={el.id}
                                    id={el.id}
                                    checked={subject_on.some((element) => {
                                      if (element.id == el.id) {
                                        return true;
                                      }

                                      return false;
                                    })}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        el.name,
                                        "subject"
                                      )
                                    }
                                  />

                                  <label
                                    className={`${styles.ellipsis} form-check-label filterChipText_withoutBG`}
                                    htmlFor={el.id}
                                    id={`${styles.td}tabTh`}
                                    title={el.name}
                                  >
                                    {el.name}
                                  </label>
                                </li>
                              ))}
                            </ul>
                          </div>

                          <div className="borderWidth row">
                            <ul className="List-Button ">
                              <li className="ListBtnItems">
                                <Link
                                  to={"javascript:void(0)"}
                                  onClick={() => handleClear("subject")}
                                  className="secondaryButton ms-2"
                                >
                                  Clear
                                </Link>
                              </li>

                              <li className="ListBtnItems">
                                <Link
                                  disabled={
                                    category_on.length === 0 ? true : false
                                  }
                                  onClick={() => handleApplyFilter("subject")}
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                  </th>

                  {/* Type of Admission */}

                  <th id="th" ref={filterTypeRef}>
                    <span
                      className="textHead_th px-1"
                      onClick={(e) => handleSort(e, "type")}
                    >
                      {" "}
                      Type of Admission
                    </span>
                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort(e, "type")}
                    >
                      import_export{" "}
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        typeOn.length > 0 ? ListInfo.active_icons : ""
                      } ${isOpen.type ? ListInfo.active_icons : ""}`} // Change here
                      onClick={(e) => handleFilter(e, "type")}
                    >
                      filter_list
                    </span>

                    {isOpen.type && (
                      <>
                        <div className="filterBoxs_testlist">
                          <div className="col-md-12 form-check filterStatus_list">
                            <ul className="ulFilterListData">
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name="Course"
                                  value="0"
                                  checked={typeOn.some((element) => {
                                    if (element.id === "0") {
                                      return true;
                                    }

                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "Course", "typeOn")
                                  }
                                  id="Course"
                                />

                                <label
                                  className="form-check-label filterChipText filterChipText_withoutBG"
                                  htmlFor="Course"
                                >
                                  Course
                                </label>
                              </li>

                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name="TestBatch"
                                  value="1"
                                  checked={typeOn.some((element) => {
                                    if (element.id === "1") {
                                      return true;
                                    }

                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      "TestBatch",
                                      "typeOn"
                                    )
                                  }
                                  id="TestBatch"
                                />

                                <label
                                  className="form-check-label filterChipText filterChipText_withoutBG"
                                  htmlFor="TestBatch"
                                >
                                  Test Batch
                                </label>
                              </li>

                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name="SpecialClass"
                                  value="3"
                                  checked={typeOn.some((element) => {
                                    if (element.id === "3") {
                                      return true;
                                    }

                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,

                                      "SpecialClass",

                                      "typeOn"
                                    )
                                  }
                                  id="SpecialClass"
                                />

                                <label
                                  className="form-check-label filterChipText filterChipText_withoutBG"
                                  htmlFor="SpecialClass"
                                >
                                  Special Class
                                </label>
                              </li>

                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name="Counselling"
                                  value="2"
                                  checked={typeOn.some((element) => {
                                    if (element.id === "2") {
                                      return true;
                                    }

                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,

                                      "Counselling",

                                      "typeOn"
                                    )
                                  }
                                  id="Counselling"
                                />

                                <label
                                  className="form-check-label filterChipText filterChipText_withoutBG"
                                  htmlFor="Counselling"
                                >
                                  Counselling
                                </label>
                              </li>

                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name="MockInterview"
                                  value="5"
                                  checked={typeOn.some((element) => {
                                    if (element.id === "5") {
                                      return true;
                                    }

                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,

                                      "MockInterview",

                                      "typeOn"
                                    )
                                  }
                                  id="MockInterview"
                                />

                                <label
                                  className="form-check-label filterChipText filterChipText_withoutBG"
                                  htmlFor="MockInterview"
                                >
                                  Mock Interview
                                </label>
                              </li>

                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name="ModelExam"
                                  value="4"
                                  checked={typeOn.some((element) => {
                                    if (element.id === "4") {
                                      return true;
                                    }

                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      "ModelExam",
                                      "typeOn"
                                    )
                                  }
                                  id="ModelExam"
                                />

                                <label
                                  className="form-check-label filterChipText filterChipText_withoutBG"
                                  htmlFor="ModelExam"
                                >
                                  Model Exam
                                </label>
                              </li>
                            </ul>
                          </div>

                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  onClick={() => handleClear("typeOn")}
                                  className="secondaryButton ms-2"
                                >
                                  Clear
                                </Link>
                              </li>

                              <li className="ListBtnItems">
                                <Link
                                  disabled={typeOn.length === 0 ? true : false}
                                  onClick={() => handleApplyFilter("typeOn")}
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                  </th>

                  {/* Category */}

                  <th id="th" ref={filterCategoryRef}>
                    <span
                      className="textHead_th px-1"
                      onClick={(e) => handleSort(e, "category")}
                    >
                      Category
                    </span>
                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort(e, "category")}
                    >
                      import_export{" "}
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        category_on.length > 0 ? ListInfo.active_icons : ""
                      } ${isOpen.category ? ListInfo.active_icons : ""}`} // Change here
                      onClick={(e) => handleFilter(e, "category")}
                    >
                      filter_list
                    </span>

                    {isOpen.category && (
                      <>
                        <div className="filterBoxs_testlist">
                          <div className="col-md-12 form-check filterStatus_list">
                            <ul className="ulFilterListData">
                              {categoryId.map((el) => (
                                <li className="filterListData">
                                  <input
                                    className="ListCheckbox"
                                    type="checkbox"
                                    name={el.name}
                                    value={el.id}
                                    id={el.name}
                                    checked={category_on.some((element) => {
                                      if (element.name == el.name) {
                                        return true;
                                      }

                                      return false;
                                    })}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        el.name,
                                        "category_on"
                                      )
                                    }
                                  />

                                  <label
                                    className="form-check-label filterChipText_withoutBG "
                                    htmlFor={el.name}
                                  >
                                    {el.name}
                                  </label>
                                </li>
                              ))}
                            </ul>
                          </div>

                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  onClick={() => handleClear("category_on")}
                                  className="secondaryButton ms-2"
                                >
                                  Clear
                                </Link>
                              </li>
                              <li className="ListBtnItems">
                                <Link
                                  disabled={
                                    category_on.length === 0 ? true : false
                                  }
                                  onClick={() =>
                                    handleApplyFilter("category_on")
                                  }
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                  </th>

                  {/* Course */}
                  <th id="th" ref={filterCourseRef}>
                    <span
                      className="textHead_th px-1"
                      onClick={(e) => handleSort(e, "course_name")}
                    >
                      {" "}
                      Course
                    </span>
                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort(e, "course_name")}
                    >
                      import_export{" "}
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        courseOn.length > 0 || isOpen.course
                          ? ListInfo.active_icons
                          : ""
                      }`}
                      onClick={(e) => handleFilter(e, "course")}
                    >
                      filter_list
                    </span>

                    {isOpen.course && (
                      <>
                        <div className="filterBoxs_testlist">
                          <div className="col-md-12 form-check filterStatus_list">
                            <ul className="ulFilterListData">
                              <div
                                class="input-group "
                                style={{
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 10,
                                  backgroundColor: "white",
                                  padding: "8px",
                                }}
                              >
                                <input
                                  type="text"
                                  class={styles.Inputs}
                                  id="SearchInput"
                                  name="SearchInput"
                                  value={search}
                                  placeholder="Search by subject"
                                  onChange={(e) => handleCourseSearch(e)}
                                />

                                <span
                                  class={styles.input_group_text}
                                  id="SearchInput"
                                  onClick={() =>
                                    handleCourseSearch(null, search)
                                  }
                                >
                                  <span
                                    className="material-icons"

                                    // onClick={handleSearchFocus}
                                  >
                                    search
                                  </span>
                                </span>
                              </div>

                              {filteredCourses.map((el) => (
                                <li className="filterListData">
                                  <input
                                    className="ListCheckbox"
                                    type="checkbox"
                                    name={el.name}
                                    value={el.id}
                                    id={el.id}
                                    checked={courseOn.some((element) => {
                                      if (element.id == el.id) {
                                        return true;
                                      }

                                      return false;
                                    })}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        el.name,
                                        "courseOn"
                                      )
                                    }
                                  />

                                  <label
                                    className={`${styles.ellipsis} form-check-label filterChipText_withoutBG`}
                                    htmlFor={el.id}
                                    id={`${styles.td}tabTh`}
                                    title={el.name}
                                  >
                                    {el.name}
                                  </label>
                                </li>
                              ))}
                            </ul>
                          </div>

                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  to={"javascript:void(0)"}
                                  onClick={() => handleClear("courseOn")}
                                  className="secondaryButton ms-2"
                                >
                                  Clear
                                </Link>
                              </li>

                              <li className="ListBtnItems">
                                <Link
                                  disabled={
                                    category_on.length === 0 ? true : false
                                  }
                                  onClick={() => handleApplyFilter("courseOn")}
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                  </th>

                  <th id="th">
                    <span className="textHead_th">Action</span>
                  </th>
                </tr>
              </thead>

              <tbody>
                {currentData.length === 0 ? (
                  <tr>
                    <td
                      colSpan="15"
                      style={{
                        textAlign: "center",

                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      No records to display
                    </td>
                  </tr>
                ) : (
                  currentData.map((course, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          className={`${styles.checkBox_input}`}
                          type="checkbox"
                          name="bookset_order"
                          id={`bookset_order_${course.test_topic_id}`}
                          value={course.test_topic_id}
                          checked={
                            Array.isArray(selectedBooks) &&
                            selectedBooks.some(
                              (b) => b?.test_topic_id === course?.test_topic_id
                            )
                          }
                          onChange={(e) =>
                            handleChangeBookOrder(e, course.test_topic_id)
                          }
                        />
                      </td>

                      <td id="td">{course.serialNumber}</td>

                      <td id={`${styles.td}tabTh`}>
                        <span
                          className={`${styles.ellipsis}`}
                          title={course.test_topic_name}
                        >
                          {course.test_topic_name}
                        </span>
                      </td>
                      <td id={`${styles.td}tabTh`}>
                        <span
                          className={`${styles.ellipsis}`}
                          title={course.subject}
                        >
                          {course.subject}
                        </span>
                      </td>
                      {course.type === 0 && (
                        <td id="td">
                          <span>Course</span>
                        </td>
                      )}

                      {course.type === 1 && (
                        <td id="td">
                          <span>Test Batch</span>
                        </td>
                      )}

                      {course.type === 2 && (
                        <td id="td">
                          <span>Counselling</span>
                        </td>
                      )}

                      {course.type === 3 && (
                        <td id="td">
                          <span>Special Class</span>
                        </td>
                      )}

                      {course.type === 4 && (
                        <td id="td">
                          <span>Model Exam </span>
                        </td>
                      )}

                      {course.type === 5 && (
                        <td id="td">
                          <span>Mock Interview </span>
                        </td>
                      )}

                      {course.type === 6 && (
                        <td id="td">
                          <span>_ </span>
                        </td>
                      )}

                      <td id="td">{course.category} </td>

                      <td id={`${styles.td}tabTh`}>
                        <span
                          className={`${styles.ellipsis}`}
                          title={course.course_name}
                        >
                          {course.course_name}
                        </span>
                      </td>

                      <td id="td">
                        <button
                          className={"view_icon_button"}
                          onClick={() => handleReadView(course.test_topic_id)}
                        >
                          <span className={` visibleicon material-icons`}>
                            visibility
                          </span>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="row mt-2">
          <Pagination
            rowsPerPage={rowsPerPage}
            handlePageCount={handlePageCount}
            startPage={
              updateListData && updateListData?.length > 0
                ? currentPage * rowsPerPage + 1 - rowsPerPage
                : 0
            }
            endPage={
              updateListData && updateListData?.length > 0
                ? updateListData?.length < currentPage * rowsPerPage
                  ? updateListData?.length
                  : currentPage * rowsPerPage
                : 0
            }
            totalRecords={
              updateListData && updateListData?.length > 0
                ? updateListData?.length
                : 0
            }
            handlePrev={(e) => handlePrev(currentPage - 1)}
            currentPrevPage={currentPage === 1}
            prevButton={`${ListInfo.prev_buttonViewEvaluator} ${ListInfo.materialIconsRightAndLeft} me-2`}
            handleNext={() => handleNext(currentPage + 1)}
            currentNextPage={currentPage === totalPages}
          />
        </div>

        {/* <Modal show={showModal} onHide={handleClose} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              <h5 class="view-title" id="exampleModalLabel">
                Remove  Topic(s)
              </h5>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="container">
              <div className="row">
                <div className="col-md-12  mb-3">
                  <div>
                    <p className="view-bold AddMargin">
                      Are you sure you want to remove the selected topic(s)?
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <p className="cancel-button" onClick={handleClose}>
              Back to Course Management
            </p>

            <button
              type="button"
              className="DashboardButton"
              onClick={handleSubmit}
            >
              <a href="javascript:void(0)">Yes, Remove</a>
            </button>
          </Modal.Footer>
        </Modal> */}
      </div>
    </>
  );
}

export default ListTestTopicInfo;
